<div *ngIf="show" class="assurant-loader-wraper">
  <div class="assurant-loader"></div>
</div>
<div *ngIf="!show">
  <div *ngIf="showProgress" class="assurant-loader-wraper assurant-loader-wraper-inpage">
    <div class="assurant-loader"></div>
    <div *ngIf="message" class="message">
       {{ message }}
    </div>
  </div>
</div>

